import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-tax-authority';
const API_DETAIL = (id: number) => `/p-tax-authority/${id}`;

export interface TaxAuthority {
  id: number;
  pt_descr?: string;
}

export const useTaxAuthoritys = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<TaxAuthority[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    taxAuthoritys: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useTaxAuthority = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<TaxAuthority>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    taxAuthority: data,
    isLoading,
    isError: error,
    mutate,
  };
};
